"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _validationRule = _interopRequireDefault(require("./validation-rule"));
var _condition = _interopRequireDefault(require("./condition"));
var _conditionalTextBlock = _interopRequireDefault(require("./conditional-text-block"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createOption = function createOption(_ref) {
  var fields = _ref.fields;
  var detailsDoc = (0, _utils.getProp)(fields, 'details');
  var details = detailsDoc ? (0, _processRichText["default"])({
    document: detailsDoc,
    factories: _standard["default"]
  }) : null;
  return _objectSpread(_objectSpread({
    text: (0, _utils.getProp)(fields, 'text'),
    value: (0, _utils.getProp)(fields, 'value')
  }, (0, _utils.getProp)(fields, 'options') || {}), {}, {
    details: details
  });
};
var createQuestion = function createQuestion(_ref2) {
  var fields = _ref2.fields;
  var infoTop = (0, _utils.getProp)(fields, 'infoTop');
  var infoTopContent = infoTop ? (0, _processRichText["default"])({
    document: infoTop,
    factories: _standard["default"]
  }) : null;
  return {
    component: (0, _utils.getProp)(fields, 'component'),
    autoComplete: (0, _utils.getProp)(fields, 'autocomplete'),
    id: (0, _utils.getProp)(fields, 'id'),
    key: (0, _utils.getProp)(fields, 'key'),
    title: (0, _utils.getProp)(fields, 'title'),
    label: (0, _utils.getProp)(fields, 'label'),
    infoTop: infoTopContent,
    additionalInfoTop: (0, _utils.getProp)(fields, 'additionalInfoTop', []).map(function (info) {
      return (0, _conditionalTextBlock["default"])(info);
    }).filter(function (info) {
      var _info$site;
      return (_info$site = info.site) === null || _info$site === void 0 ? void 0 : _info$site.includes(process.env.NEXT_PUBLIC_SITE);
    }),
    additionalInfoBottom: (0, _utils.getProp)(fields, 'additionalInfoBottom', []).map(function (info) {
      return (0, _conditionalTextBlock["default"])(info);
    }).filter(function (info) {
      var _info$site2;
      return (_info$site2 = info.site) === null || _info$site2 === void 0 ? void 0 : _info$site2.includes(process.env.NEXT_PUBLIC_SITE);
    }),
    options: (0, _utils.getProp)(fields, 'options') ? fields.options.map(function (option) {
      return createOption(option);
    }) : [],
    validations: (0, _utils.getProp)(fields, 'validations') ? fields.validations.map(function (validation) {
      return (0, _validationRule["default"])(validation);
    }) : [],
    conditions: (0, _utils.getProp)(fields, 'conditions') ? fields.conditions.map(function (condition) {
      return (0, _condition["default"])(condition);
    }) : []
  };
};
var _default = createQuestion;
exports["default"] = _default;